import { Application } from 'app-core/src/models/application.model';
import { Game } from 'app-core/src/models/game.model';
import { DelegateProvider } from 'app-core/src/interfaces/delegate-provider.interface';

export const kNameOfTesterWindowManagerService = 'TesterWindowManagerService';

// -----------------------------------------------------------------------------
export interface ITesterWindowManagerServiceDelegate {
  onTestingNotificationSet(
    game: Game,
    application: Application,
    useDevEnv: string,
  );
}

// -----------------------------------------------------------------------------
// This is the background interface for NotificationWindowServiceImpl - which
// communicates with the notification window
export interface ITesterWindowManagerService
  extends DelegateProvider<ITesterWindowManagerServiceDelegate> {
  setActiveNotification?(notification: any);
  notificationAlreadyRunning?(isRunning: boolean);
}
